import { inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class BrowserContext {
  private readonly platformId = inject(PLATFORM_ID);
  readonly document = inject<Document>(DOCUMENT);
  readonly isBrowser = isPlatformBrowser(this.platformId);

  get window(): Window {
    const view = this.document.defaultView;
    if (!view) {
      throw new Error('window is not available in this context');
    }
    return view;
  }
}
